module.exports = __webpack_public_path__ + "static/img/h_27@2x.4a10a1dc.png";